import matchHeight from "./match-height";

const lgc = {

init(){
    jQuery( document ).ready(function($) {

        $('.off-canvas-close').on('click', function(){
            $('.off-canvas').addClass('hide');
        })
        $('.off-canvas-open').on('click', function(){
            $('.off-canvas').removeClass('hide');
        })

            $('.wp-block-video').on('click', function(){
                if($(this).hasClass('paused')){
                    let vid = $(this).find('video').get(0);
                    vid.play()
                    $(this).addClass('playing');
                    $(this).removeClass('paused');
                }else{
                    $(this).find('video').get(0).pause();
                    $(this).removeClass('playing');
                    $(this).addClass('paused');
                }
            })



    })
}}

export default lgc;

